/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { WhatIfData } from "../../../../models/http/what-if/what-if-data.model";

export const GET_USER_WHAT_IF_DATA_RESPONSE: Record<string, WhatIfData> = {
	"GCP Application": {
		scenarios: [
			{
				id: 1337,
				name: "Baseline",
				isBaseline: true
			},
			{
				id: 1335,
				name: "Scenario 1",
				isBaseline: false
			},
			{
				id: 80885,
				name: "Scenario 2",
				isBaseline: false
			}
		],
		barChart: {
			title: "Chart title",
			barSeries: [
				{
					name: "Serie 1",
					bars: [
						{
							name: "Baseline",
							value: 10,
							unit: "kgCO2e",
							tenantRegion: true,
							baselineValue: 10
						},
						{
							name: "Scenario 1",
							value: 0,
							unit: "kgCO2e",
							tenantRegion: true,
							percentageDiff: 10,
							baselineValue: 10
						},
						{
							name: "Scenario 2",
							value: 0,
							unit: "kgCO2e",
							tenantRegion: true,
							percentageDiff: 10,
							baselineValue: 10
						}
					]
				},
				{
					name: "Serie 2",
					bars: [
						{
							name: "Baseline",
							value: 0,
							unit: "kgCO2e",
							tenantRegion: true,
							baselineValue: 10
						},
						{
							name: "Scenario 1",
							value: 20,
							unit: "kgCO2e",
							tenantRegion: true,
							percentageDiff: 100,
							baselineValue: 10
						},
						{
							name: "Scenario 2",
							value: 5,
							unit: "kgCO2e",
							tenantRegion: true,
							percentageDiff: -50,
							baselineValue: 10
						}
					]
				}
			]
		}
	},
	"Web Logic": {
		scenarios: [
			{
				id: 1337,
				name: "Baseline",
				isBaseline: true
			}
		],
		barChart: {
			title: "Chart title",
			barSeries: [
				{
					name: "Serie 1",
					bars: [
						{
							name: "Baseline",
							value: 10,
							unit: "kgCO2e",
							tenantRegion: true,
							baselineValue: 10
						},
						{
							name: "Scenario 1",
							value: 0,
							unit: "kgCO2e",
							tenantRegion: true,
							percentageDiff: 10,
							baselineValue: 10
						},
						{
							name: "Scenario 2",
							value: 0,
							unit: "kgCO2e",
							tenantRegion: true,
							percentageDiff: 10,
							baselineValue: 10
						}
					]
				},
				{
					name: "Serie 2",
					bars: [
						{
							name: "Baseline",
							value: 0,
							unit: "kgCO2e",
							tenantRegion: true,
							baselineValue: 10
						},
						{
							name: "Scenario 1",
							value: 20,
							unit: "kgCO2e",
							tenantRegion: true,
							percentageDiff: 100,
							baselineValue: 10
						},
						{
							name: "Scenario 2",
							value: 5,
							unit: "kgCO2e",
							tenantRegion: true,
							percentageDiff: -50,
							baselineValue: 10
						}
					]
				}
			]
		}
	}
};
